<template>
  <span
    :key="siteType.id"
    class="rounded-pill bg-gray-100 text-nowrap d-flex align-items-center"
    :style="{
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: small ? 'var(--gray-300)' : siteType.kind ? siteType.kind.color : 'var(--gray-600)',
      padding: paddingString,
      fontSize: small ? '0.75em' : '1em',
    }"
  >
    <b-icon
      v-if="!small && siteType.kind && siteType.kind.icon.tag === 'b-icon'"
      v-bind="siteType.kind.icon.attrs"
      class="rounded-circle"
      variant="light"
      font-scale="1.5"
      :style="{
        backgroundColor: siteType.kind ? siteType.kind.color : 'var(--gray-600)',
        padding: '0.2em',
      }"
    ></b-icon>
    <span
      v-else
      class="company-sites-manager__kind-dot"
      :style="{ backgroundColor: siteType.kind ? siteType.kind.color : 'var(--gray-600)' }"
    ></span>
    <span
      class="special-text text-dark"
      :style="{ marginLeft: small ? '0.2em' : '0.4em' }"
      >{{ siteType.name }}</span
    >
  </span>
</template>

<script>
  export default {
    name: 'CompanySiteTypeBadge',
    components: {},
    mixins: [],
    props: {
      siteType: {
        type: Object, // full nested object passed from backend serializer
        required: true,
      },
      small: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {};
    },
    computed: {
      hasIcon() {
        return !this.small && this.siteType.kind && this.siteType.kind.icon.tag === 'b-icon';
      },
      paddingString() {
        if (this.small) {
          return '0.1em 0.4em';
        }
        if (this.hasIcon) {
          return '0 0.6em 0 0';
        }
        return '0.1em 0.6em'; // just a large dot
      },
    },
    created() {},
    mounted() {},
    methods: {},
  };
</script>

<style scoped>
  .company-sites-manager__kind-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 4px;
  }
</style>
